import { useTranslation } from "@next-platform/client-common-core";
import { useCallback, useMemo } from "react";

const useFilterOptionAriaLabels = () => {
  const { t } = useTranslation();
  const getIncludeAriaLabel = useCallback((label: string) => t("chatbotFilters:filterOption.include", { label }), [t]);
  const getExcludeAriaLabel = useCallback((label: string) => t("chatbotFilters:filterOption.exclude", { label }), [t]);
  return useMemo(() => ({ getIncludeAriaLabel, getExcludeAriaLabel }), [getIncludeAriaLabel, getExcludeAriaLabel]);
};

export default useFilterOptionAriaLabels;
